<template>
	<div class="size-field-wrap">
		<div class="form-field">
			<label>尺寸</label>
			<div class="content">
				<el-input size="mini" class="form-input" type="number" :min="0" :max="180" :step="1" :value="width" @focus="setId"
					@input="setWidth"/>
				<el-input size="mini" class="form-input" type="number" :min="0" :max="180" :step="1" :value="height" @focus="setId"
					@input="setHeight"/>
			</div>
		</div>
		<el-checkbox v-model="restrain" style="margin-left: 46px">等比例约束</el-checkbox>
	</div>
</template>

<script>
	export default {
		props: {
			ratio: Number
		},
		data() {
			return {
				id: null,
				restrain: true
			}
		},
		computed: {
			selected() {
				return this.$store.state.selected
			},
			width() {
				return this.selected.width
			},
			height() {
				return this.selected.height
			},
		},
		methods: {
			setId() {
				this.id = this.selected.id
			},
			setWidth(value) {
				let res = {
					width: +value,
				}
				if(this.restrain) {
					res.width = +value || 1
					res.height = res.width/this.ratio || 1
					// res.height = res.height >= 2 ? Math.round(res.height) : +res.height.toFixed(4)
				}
				this.$store.commit('update_elm', {
					id: this.id,
					data: res
				})
				// console.log(this.ratio)
				this.$store.dispatch('elm_select',{id: this.id})
			},
			setHeight(value) {
				let res = {
					height: +value,
				}
				if(this.restrain) {
					res.height = +value || 1
					res.width = res.height*this.ratio || 1
					// res.width = res.width >= 2 ? Math.round(res.width) : +res.width.toFixed(4)
				}
                this.$store.commit('update_elm', {
                	id: this.id,
                    data: res
                })
                this.$store.dispatch('elm_select',{id: this.id})
			}
		}
	}
</script>

<style lang="scss" scoped>
    input {
        width: 83px;
    }
	#attribute-form .form-group > .size-field-wrap{
		padding: 0;
		margin-right: 0
	}
    .content {
        display: flex;
        > div {
            /*flex: 1;*/
            margin-right: 10px;
			width: 70px;
        }
        > input {
            width:70px;
            padding: 0 6px;
			font-size: 12px;
			color: rgba(0, 0, 0, .65)
        }
    }
</style>
